import styled from 'styled-components'

export const DetailMessage = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 200px;
  color: var(--color-action-default);
`
